'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { InternalProvider, useComponentDeprecation } from '../../util';
import { ChevronWrapper, IconWrapper, StyledCardStrip } from './ButtonSelectionCardElements';
import { Icon } from '../Icon';
/**
 * @deprecated
 */
export const ButtonSelectionCard = /*#__PURE__*/React.forwardRef(({
  buttonClassName = '',
  iconWrapperClassName = '',
  disabled = false,
  iconSrc,
  children,
  chevronClassName,
  disableSvgColorOverride,
  ...rest
}, fRef) => {
  useComponentDeprecation({
    name: 'ButtonSelectionCard',
    alternative: 'ActionCard',
    version: '5'
  });
  const renderIcon = () => /*#__PURE__*/React.createElement(IconWrapper, {
    className: iconWrapperClassName
  }, /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc,
    fill: "currentColor",
    size: "large"
  }));
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(StyledCardStrip, _extends({
    ref: fRef,
    "data-aui": "button-selection-card",
    className: buttonClassName,
    disabled: disabled,
    disableSvgColorOverride: disableSvgColorOverride,
    element: "button"
  }, rest), iconSrc && renderIcon(), children, /*#__PURE__*/React.createElement(ChevronWrapper, null, /*#__PURE__*/React.createElement(Icon.SSR, {
    className: chevronClassName,
    src: "cards-navigation-chevron-right",
    size: "large"
  }))));
});